import { Link } from 'react-router-dom'
import { mediaUrl } from '../../utils/media'
import { STATUS_CSS } from '../../utils/constants'

export default function MangaCard({ manga, meta }) {
  if (!manga) return null

  const slug = manga.slug || manga.id
  const cover = mediaUrl(manga.cover_url)
  const statusName = meta?.statuses?.find(s => s.code === manga.status)?.name

  return (
    <Link to={`/manga/${slug}`} className="group block transition-transform duration-200 hover:-translate-y-1">
      <div className="relative overflow-hidden bg-surface2" style={{ aspectRatio: '2/3', borderRadius: 'var(--radius-cover)' }}>
        {cover ? (
          <img
            src={cover}
            alt={manga.title}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-4xl text-muted">📖</div>
        )}

        {/* Gradient overlay — always dark, intentional */}
        <div
          className="absolute inset-0"
          style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.04) 68%)' }}
        />

        {/* Accent ring on hover */}
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 manga-cover-ring" />

        {statusName && (
          <div
            className={`absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md text-xs font-semibold ${STATUS_CSS[manga.status]}`}
            style={{ background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)' }}
          >
            {statusName}
          </div>
        )}

        {(() => {
          const showSite = manga.rating_count > 4
          if (showSite) return (
            <div className="absolute top-2.5 right-2.5 flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-xs font-bold text-accent"
              style={{ background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)' }}>
              ★ {Number(manga.rating).toFixed(1)}
            </div>
          )
          if (manga.shikimori_rating) return (
            <div className="absolute top-2.5 right-2.5 flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-xs font-bold text-accent"
              style={{ background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)' }}>
              <span className="font-normal opacity-60">S</span>★ {Number(manga.shikimori_rating).toFixed(1)}
            </div>
          )
          return null
        })()}

        <div className="absolute bottom-0 left-0 right-0 p-3 flex flex-col gap-1">
          <p className="text-sm font-semibold leading-snug line-clamp-2 text-white">
            {manga.title}
          </p>
          {manga.chapters_count != null && (
            <p className="text-xs text-white/45">{manga.chapters_count} гл.</p>
          )}
        </div>
      </div>
    </Link>
  )
}
